import React from 'react';

export default function MakeImg({ make = null, makeUrlSafe = null, modelId = null, className = '', ...other }) {
  if (modelId && !make) {
    make = modelId.split('-')[0];
  }

  const fixedMake = makeUrlSafe || (make || 'unknown').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

  return <span className={`MakeLogo MakeLogo--small ${className}`} {...other}>
    <img src={`https://static.opinautos.com/images/logos-transparent/${fixedMake}.png`}
      loading='lazy'
      decoding='async'
      alt={make}
      title={make}
      className='MakeLogo__img'
      style={{ height: '24px', width: '36px', objectFit: 'contain' }} />
  </span>;
}
